// libraries
import { useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import classnames from "classnames";
import { useToasts } from "react-toast-notifications";
import firebase from "../firebase/firebase";

// styles
import "../styles/ExtraStyling.css";

// context
import UserContext from "../context/user";

// components
import Loading from "./Loading";

const LoginModal = (props) => {
  // use context
  const { loading, setLoading, forgotPassword } = useContext(UserContext);

  // use states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [fullname, setFullname] = useState("");
  const [flag, setFlag] = useState(false);

  // use toast
  const { addToast } = useToasts();

  const userDocument = firebase.firestore().collection("users");

  let isLoginEmpty = !email || !password;
  let isSignupEmpty = !email || !password || !username || !fullname;

  const handleSignupSumbit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(function (data) {
          data.user.updateProfile({
            displayName: fullname,
          });
          const id = data.user.uid;
          userDocument
            .doc(id)
            .set({
              id,
              email,
              username,
            })
            .then(() => {
              setLoading(false);
            })
            .catch((e) => {
              setLoading(false);
              console.log(e);
              addToast(e.message, {
                appearance: "error",
              });
            });
        });
    } catch (e) {
      setLoading(false);
      console.log(e);
      addToast(e.message, {
        appearance: "error",
      });
    }
  };

  const handleLoginSumbit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(() => {
          setLoading(false);
        });
    } catch (e) {
      setLoading(false);
      console.log(e);
      addToast(e.message, {
        appearance: "error",
      });
    }
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (email !== "") {
      if (forgotPassword(email)) {
        addToast(`Email is being sent to ${email}`, {
          appearance: "success",
        });
      } else {
        addToast(`someting went wrong`, {
          appearance: "error",
        });
      }
    }
  };

  const { buttonLabel, className, buttonClassName } = props;

  const [modal, setModal] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  const modalToggle = () => setModal(!modal);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (loading) {
    return <Loading fixed={true} />;
  }

  return (
    <div>
      <div className={buttonClassName} onClick={modalToggle}>
        {buttonLabel}
      </div>
      <Modal
        isOpen={modal}
        modalTransition={{ timeout: 700 }}
        backdropTransition={{ timeout: 1300 }}
        toggle={modalToggle}
        className={className}
      >
        <ModalHeader toggle={modalToggle}>
          <Nav tabs>
            <NavItem className="cursor-pointer">
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  toggle("1");
                }}
              >
                Login
              </NavLink>
            </NavItem>
            <NavItem className="cursor-pointer">
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Signup
              </NavLink>
            </NavItem>
          </Nav>
        </ModalHeader>
        <ModalBody>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">
                  {!flag ? (
                    <Form>
                      <span
                        className="forget_pass"
                        onClick={() => setFlag(true)}
                      >
                        Forget Password
                      </span>
                      <FormGroup>
                        <Label for="loginEmail">Email</Label>
                        <Input
                          type="email"
                          name="loginEmail"
                          id="loginEmail"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="loginPassword">Password</Label>
                        <Input
                          type="password"
                          name="loginPassword"
                          id="loginPassword"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </FormGroup>
                      {isLoginEmpty && (
                        <p className="my-2">Please fill out all the fields</p>
                      )}
                      {!isLoginEmpty && (
                        <Button
                          className="btn btn-primary py-3 px-5"
                          onClick={handleLoginSumbit}
                        >
                          Login
                        </Button>
                      )}
                    </Form>
                  ) : (
                    <Form>
                      <span
                        className="forget_pass"
                        onClick={() => setFlag(true)}
                      >
                        Forget Password
                      </span>
                      <FormGroup>
                        <Label for="loginEmail">Email</Label>
                        <Input
                          type="email"
                          name="loginEmail"
                          id="loginEmail"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </FormGroup>
                      <Button
                        className="btn btn-primary py-3 px-5 btn-block"
                        onClick={handleResetPassword}
                      >
                        Reset Password
                      </Button>
                    </Form>
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12">
                  <Form>
                    <FormGroup>
                      <Label for="username">Username</Label>
                      <Input
                        type="text"
                        name="username"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="fullname">Full Name</Label>
                      <Input
                        type="text"
                        name="fullname"
                        id="fullname"
                        value={fullname}
                        onChange={(e) => setFullname(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="signupEmail">Email</Label>
                      <Input
                        type="email"
                        name="signupEmail"
                        id="signupEmail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="signupPassword">Password</Label>
                      <Input
                        type="password"
                        name="signupPassword"
                        id="signupPassword"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </FormGroup>
                    {isSignupEmpty && (
                      <p className="my-2">Please fill out all the fields</p>
                    )}
                    {!isSignupEmpty && (
                      <Button
                        className="btn btn-primary py-3 px-5"
                        onClick={handleSignupSumbit}
                      >
                        Signup
                      </Button>
                    )}
                  </Form>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LoginModal;
